<template>
        <div class="p-6 mt-2 max-w-full">
    <!-- Header -->
    <div class="flex items-center justify-between mb-8 pb-4 border-b border-gray-200 mt-20">
      <h1 class="text-2xl font-bold text-[#035a76]">New Employment Contract</h1>
      <button @click="$emit('back')" class="text-gray-500 hover:text-gray-700 transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div class="space-y-10">
      <!-- SECTION 1: Employee & Basic Contract Info -->
      <div class="mb-8 p-6 border rounded-lg bg-gray-50">
        <h2 class="text-xl font-semibold mb-6">Employee & Contract Basics</h2>
        
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <!-- <div>
            <label class="block text-sm font-medium text-gray-700">Select Employee*</label>
            <select v-model="contract.employee" required
                    class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3">
              <option disabled value="">Select an employee</option>
              <option v-for="applicant in filteredApplicants" :key="applicant.id" :value="applicant.id">
                {{ applicant.name }}
              </option>
            </select>
          </div> -->
<div>
  <label class="block text-sm font-medium text-gray-700">Select Employee*</label>
  <Multiselect
    v-model="selectedEmployeeModel"
    :options="filteredApplicants"
    :custom-label="app => app.name"
    track-by="id"
    searchable
    placeholder="Search employee..."
    :show-labels="false"
    class="mt-1"
  />
</div>

          <div>
            <label class="block text-sm font-medium text-gray-700">Employee Code</label>
            <input 
              :value="generatedEmployeeCode || 'N/A'" 
              readonly
              class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 bg-gray-100"
              :class="{'border-green-500': hasAcceptedDraft}"
            >
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700">Contract Type*</label>
            <select v-model="contract.type" required
                    class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
              <option disabled value="">Select type</option>
              <option v-for="type in contracts" :key="type.id" :value="type.id">
                {{ type.name }}
              </option>
            </select>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700">Duration (months)*</label>
            <input v-model.number="contract.duration" type="number" min="1" required
                   class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
          </div>
        </div>

        <div class="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div>
            <label class="block text-sm font-medium text-gray-700">Start Date*</label>
            <input v-model="contract.startDate" type="date" required
                   class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700">End Date</label>
            <input v-model="contract.endDate" type="date"
                   :readonly="contract.autoCalculateEndDate"
                   class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]"
                   :class="{'bg-gray-100': contract.autoCalculateEndDate}">

                             <div class="mt-6">
            <div class="flex items-center">
              <input id="auto-calculate" v-model="contract.autoCalculateEndDate" type="checkbox"
                     class="h-4 w-4 text-[#035a76] focus:ring-[#035a76] border-gray-300 rounded">
              <label for="auto-calculate" class="ml-2 block text-sm text-gray-700">
                Auto-calculate end date
              </label>
            </div>
          </div>
          </div>

          <!-- <div>
            <label class="block text-sm font-medium text-gray-700">Emmployee Type</label>
              <select v-model="contract.employeeType"
                      class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                <option disabled value="">Select type</option>
                <option value="Old">Old</option>
                <option value="New">New</option>
              </select>
          </div> -->
          <div>
              <label class="block text-sm font-medium text-gray-700">Language of Support</label>
              <select v-model="contract.language"
                      class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                <option disabled value="">Select </option>
                <option value="French">French</option>
                <option value="English">English</option>
              </select>
            </div>
                  <div>
            <label class="block text-sm font-medium text-gray-700">Report To*</label>
            <select v-model="contract.report" required
                    class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
              <option disabled value="">Select Position</option>
              <option v-for="position in positions" :key="position.id" :value="position.id">{{ position.name }}</option>
            </select>
          </div>


          <div v-if="hasAcceptedDraft && !isPrefilling" class="mb-4 flex items-center">
            <span class="inline-flex items-center px-3 py-1 rounded text-sm font-medium bg-green-100 text-green-800">
              ✓ Form pre-filled from accepted contract
            </span>
          </div>
        </div>

        <div v-if="isPrefilling" class="mt-6 text-sm text-gray-500">
          Loading previous contract...
        </div>
      </div>

      <!-- SECTION 2: Position -->
      <div class="mb-8 p-6 border rounded-lg bg-white">
        <h2 class="text-xl font-semibold border-b pb-2 mb-6">Position Details</h2>
        
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div>
            <label class="block text-sm font-medium text-gray-700">Department*</label>
            <select v-model="contract.department" required
                    class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
              <option disabled value="">Select department</option>
              <option v-for="department in departments" :key="department.id" :value="department.id">{{ department.name }}</option>
            </select>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700">Job Title/Position*</label>
            <select v-model="contract.position" required
                    class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
              <option disabled value="">Select Position</option>
              <option v-for="position in positions" :key="position.id" :value="position.id">{{ position.name }}</option>
            </select>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700">Probation Period</label>
            <select v-model="contract.probationPeriod"
                    class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
              <option value="0">No probation</option>
              <option value="1">1 month</option>
              <option value="3">3 months</option>
              <option value="6">6 months</option>
              <option value="12">12 months</option>
            </select>
          </div>
        </div>

        <!-- Teaching fields – kept almost original but in horizontal layout -->
        <div v-if="contract.department == 1 || contract.department == 6 || contract.department == 14" class="mt-8 pt-6 border-t">
          <h3 class="text-lg font-medium mb-4">Teaching Specific Details</h3>
          
        <div class="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div>
              <label class="block text-sm font-medium text-gray-700">Section*</label>
              <select v-model="contract.section"
                      class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                <option disabled value="">Select section</option>
                <option v-for="section in sections" :key="section.id" :value="section.id">{{ section.name }}</option>
              </select>
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700">Class Assignment*</label>
              <select v-model="contract.class"
                      class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                <option value="">Select class</option>
                <option v-for="item in filteredClasses" :key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
            </div>

            <!-- <div>
              <label class="block text-sm font-medium text-gray-700">Language of Support</label>
              <select v-model="contract.language"
                      class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                <option disabled value="">Select </option>
                <option value="Frecnh">Frecnh</option>
                <option value="English">English</option>
              </select>
            </div> -->

            <div>
              <label class="block text-sm font-medium text-gray-700">Subjects</label>
              <div class="space-y-3 mt-1">
                <div v-for="(subjectId, index) in contract.subjects" :key="index" class="flex items-center gap-3">
                  <select 
                    v-model="contract.subjects[index]" 
                    class="flex-1 border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                    <option disabled value="">Select a subject</option>
                    <option v-for="subj in subjects" :key="subj.id" :value="subj.id">
                      {{ subj.name }} {{ subj.code ? `(${subj.code})` : '' }}
                    </option>
                  </select>

                  <button 
                    v-if="contract.subjects.length > 1" 
                    @click="removeSubject(index)" 
                    type="button"
                    class="text-red-600 hover:text-red-800 p-1"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                <button 
                  @click="addSubject" 
                  type="button"
                  class="mt-2 inline-flex items-center px-3 py-1 border border-transparent text-sm font-medium rounded text-[#035a76] bg-[#035a76]/10 hover:bg-[#035a76]/20"
                >
                  + Add Subject
                </button>

                <div v-if="contract.subjects.some(id => id)" class="mt-2 text-xs text-gray-500">
                  Selected: {{ selectedSubjectNames }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Salary + Termination side by side -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <!-- Salary & Benefits -->
        <div class="mb-8 p-6 border rounded-lg bg-white">
          <h2 class="text-xl font-semibold border-b pb-2 mb-6">Salary & Benefits</h2>
          
          <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div v-if="hasPermission('contracts', 'add_salary')">
              <label class="block text-sm font-medium text-gray-700">Base Salary (GHS)*</label>
              <input v-model.number="contract.salary" type="number" min="0" required
                     class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700">Payment Frequency*</label>
              <select v-model="contract.paymentFrequency" required
                      class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                <option value="monthly">Monthly</option>
                <option value="bi-weekly">Bi-Weekly</option>
                <option value="weekly">Weekly</option>
              </select>
            </div>
              <div>
              <label class="block text-sm font-medium text-gray-700">Leave Days*</label>
              <input v-model.number="contract.leaveDays" type="number" min="0" required
                     class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700">SSNIT Contribution</label>
              <select v-model="contract.ssnit"
                      class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                <option disabled value="">Select option</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700">PAYE</label>
              <select v-model="contract.paye"
                      class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                <option disabled value="">Select option</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
          </div>

          <div class="mt-6" v-if="hasPermission('contracts', 'add_benefit')">
            <label class="block text-sm font-medium text-gray-700">
              Additional Benefits
            </label>
          
            <!-- Yes / No Select -->
            <select
              v-model="contract.hasBenefits"
              class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]"
            >
              <option disabled value="">Select benefits</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          
            <!-- Conditional Fields -->
<div v-if="contract.hasBenefits === 'Yes'">
  <label class="block text-sm font-medium text-gray-700 mt-4">Benefits</label>

  <div class="space-y-3 mt-1">
    <div
      v-for="(benefit, index) in contract.benefits"
      :key="index"
      class="flex items-center gap-3"
    >
      <!-- Select -->
      <select
        v-model="benefit.type"
        class="flex-1 border border-gray-300 rounded-md py-2 px-3"
      >
        <option disabled value="">Select benefit</option>
        <option v-for="b in benefits" :key="b.id" :value="b.id">
          {{ b.name }}
        </option>
      </select>

      <!-- Amount -->
      <input
        type="number"
        v-model="benefit.amount"
        placeholder="Amount"
        class="w-32 border border-gray-300 rounded-md py-2 px-3"
      />

      <!-- Remove -->
      <button
        v-if="contract.benefits.length > 1"
        @click="removeBenefit(index)"
        type="button"
        class="text-red-600 hover:text-red-800 p-1"
      >
        ✕
      </button>
    </div>

    <!-- Add button -->
    <button
      @click="addBenefit"
      type="button"
      class="mt-2 inline-flex items-center px-3 py-1 text-sm rounded text-[#035a76] bg-[#035a76]/10 hover:bg-[#035a76]/20"
    >
      + Add Benefit
    </button>
    <div v-if="Array.isArray(contract.benefits) && contract.benefits.some(b => b.type || b.amount)" class="mt-2 text-xs text-gray-500">
  Selected: {{ selectedBenefitNames }}
</div>
  </div>
</div>
          </div>
        </div>

        <!-- Termination -->
        <div class="mb-8 p-6 border rounded-lg bg-white">
          <h2 class="text-xl font-semibold border-b pb-2 mb-6">Termination Clause</h2>
          
          <div class="flex items-center mb-4">
            <input id="include-termination" v-model="contract.includeTermination" type="checkbox"
                   class="h-4 w-4 text-[#035a76] focus:ring-[#035a76] border-gray-300 rounded">
            <label for="include-termination" class="ml-2 block text-sm text-gray-700">
              Include termination clause
            </label>
          </div>
          
          <div v-if="contract.includeTermination" class="space-y-6">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label class="block text-sm font-medium text-gray-700">Notice Period (days)*</label>
                <input v-model.number="contract.noticePeriod" type="number" min="1"
                       class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700">Termination Reason Required</label>
                <select v-model="contract.terminationReasonRequired"
                        class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]">
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700">Termination Conditions</label>
              <textarea v-model="contract.terminationConditions" rows="3"
                        class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#035a76] focus:border-[#035a76]"></textarea>
            </div>
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="flex justify-end space-x-4 mt-10 pt-6 border-t border-gray-200">
        <button type="button" @click="resetForm"
                class="inline-flex items-center px-5 py-2.5 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#035a76]">
          Reset
        </button>
        <!-- <button type="button" 
@click="handleDownloadContract"
                :disabled="isSaving || !hasAcceptedDraft"
                class="inline-flex items-center px-5 py-2.5 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#035a76]">  
📄 Download Professional PDF        
        </button> -->
<button
  v-if="existingDraft?.id"
  type="button"
  @click="updateContract"
  :disabled="isSaving"
  class="inline-flex items-center px-5 py-2.5 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700"
>
  {{ isSaving ? 'Updating...' : 'Update Draft' }}
</button>
        <button 
          type="button" 
          @click="saveContract" 
          :disabled="isSaving || hasAcceptedDraft"
          class="inline-flex items-center px-5 py-2.5 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-amber-500 hover:bg-amber-600 disabled:opacity-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500">
          {{ isSaving ? 'Saving...' : 'Generate Draft' }}
        </button>
        <button 
          type="button" 
          @click="generateContract"
          :disabled="isSaving || !hasAcceptedDraft"
          class="inline-flex items-center px-5 py-2.5 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-[#76ba51] hover:bg-[#66a345] disabled:opacity-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#035a76]">
          {{ isSaving ? 'Generating...' : 'Save Contract' }}
        </button>
      </div>
    </div>
    <!-- Hidden PDF Template Container -->
<div id="pdf-template" style="display: none; width: 800px; padding: 40px; background: white; font-family: 'Times New Roman', serif;">
  <!-- Content will be injected here -->
</div>
  </div>
</template>
  
  <script setup>
  import { ref, watch, computed, onMounted, h, nextTick } from 'vue';
  import api from "@/services/api"
  import html2pdf from 'html2pdf.js'
//   import HrSidebar from '../../components/hr/HrSidebar.vue';
//   import HrTopbar from '../../components/hr/HrTopbar.vue';

//   const isSidebarOpen = ref(true);
//   const isDarkMode = ref(false);
//   const selectedPeriod = ref('month');
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css'

const applicants = ref([]);
const selectedEmployee = ref(""); 

const contracts = ref([]);

const departments = ref([]);

const positions = ref([]);

const sections = ref([]);

const classes = ref([]);

const subjects = ref([]);

const benefits = ref([]);

const generatedEmployeeCode = ref('');
const isPrefilling = ref(false);
const hasAcceptedDraft = ref(false);
const isSaving = ref(false);
const existingDraft = ref(null);

import { usePermissions } from '@/composables/usePermissions'

const { hasPermission } = usePermissions()

const selectedSubjectNames = computed(() => {
  if (!contract.value.subjects) return "";

  return contract.value.subjects
    .map(id => {
      const subject = subjects.value.find(s => String(s.id) === String(id));
      return subject ? subject.name : null;
    })
    .filter(Boolean)
    .join(", ");
});

const selectedBenefitNames = computed(() => {
  if (!contract.value.benefits) return "";

  return contract.value.benefits
    .map(b => {
      const benefit = benefits.value.find(x => String(x.id) === String(b.type));
      return benefit ? `${benefit.name} (${b.amount})` : null;
    })
    .filter(Boolean)
    .join(", ");
});

const selectedEmployeeModel = computed({
  get() {
    if (!contract.value.employee) return null;
    return filteredApplicants.value.find(app => String(app.id) === String(contract.value.employee)) || null;
  },
  set(newValue) {
    contract.value.employee = newValue ? newValue.id : '';
  }
});
const fetchApplicants = async () => {
  try {
    const response = await api.get("Applicants.php");

    applicants.value = response.data.map(applicant => ({
      id: applicant.id,
      name: applicant.full_name,
      position: applicant.position_title,
      status: applicant.applicant_status,

    }));

  } catch (error) {
    console.error("Error fetching Applicants:", error);
  }
}
const filteredApplicants = computed(() => {
return applicants.value.filter(applicant =>
  applicant.status?.toLowerCase() === "validated" ||
  applicant.status?.toLowerCase() === "contracting"
);
});
const fetchContractType = async () => {
  try{
    const response = await api.get("ContractType.php");
    contracts.value = response.data.map(contract => ({
      id:contract.id,
      name:contract.name,
      code:contract.code,
      description:contract.description,
      duration:contract.duration
    }));

  } catch (error) {
    console.error("Error fetching COntract Types:", error);
  }
};
const fetchDepartments = async () => {
  try{
    const response = await api.get("Departments.php");
    departments.value = response.data.map(department => ({
      id:department.id,
      name:department.name,
      code:department.code,
      description:department.description
    }));

  } catch (error) {
    console.error("Error fetching Departments:", error);
  }
};

const fetchPositions = async () => {
  try {
    const response = await api.get("Positions.php");

    positions.value = response.data.map(position => ({
      id: position.id,
      department_id: position.department_id,
      department_name : position.department_name,
      name: position.title,
      code: position.code,
      description: position.description
    }));

  } catch (error) {
    console.error("Error fetching Positions:", error);
  }
};
const fetchSections = async () => {
  try{
    const response = await api.get("Sections.php");
    sections.value = response.data.map(section => ({
      id:section.id,
      name:section.name,
      code:section.code,
      description:section.description
    }));

  } catch (error) {
    console.error("Error fetching Sections:", error);
  }
};
const fetchClasses = async () => {
  try {
    const response = await api.get("Classes.php");

    classes.value = response.data.map(item => ({
      id: item.id,
      section_id: item.section_id,
      section_name: item.section_name,
      name: item.name,
      code: item.code,
      description: item.description
    }));

  } catch (error) {
    console.error("Error fetching Classes:", error);
  }
};
const fetchSubjects = async () => {
  try{
    const response = await api.get("Subjects.php");
    subjects.value = response.data.map(subject => ({
      id:subject.id,
      name:subject.name,
      code:subject.code,
      description:subject.description
    }));

  } catch (error) {
    console.error("Error fetching Subjects:", error);
  }
};
const fetchBenefits = async () => {
  try{
    const response = await api.get("Benefits.php");
    benefits.value = response.data.map(benefit => ({
      id:benefit.id,
      name:benefit.name,
      code:benefit.code,
      description:benefit.description
    }));

  } catch (error) {
    console.error("Error fetching Benefits:", error);
  }
};
const filteredClasses = computed(() => {
  if (!contract.value.section) return [];

  const selectedSectionId = contract.value.section; 

  return classes.value.filter(cls => 
    String(cls.section_id) === String(selectedSectionId)
  );
});
  

  
// const selectedEmployeeDetails = computed(() => {
//   return filteredApplicants.value.find(app => app.id === selectedEmployee.value) || null;
// });
const selectedEmployeeDetails = computed(() => {
  return filteredApplicants.value.find(app => String(app.id) === String(contract.value.employee)) || null;
});
  
  const emit = defineEmits(['back', 'submit']);

  const contract = ref({
    employee: '',
    type: '',
    duration: 0,
    probationPeriod: '3',
    startDate: '',
    endDate: '',
    language: '',
    report : '',
    autoCalculateEndDate: true,
    department: '',
    position: '',
    section: '',
    class: '',
    subjects: [''],
    salary: 0,
    paymentFrequency: 'monthly',
    leaveDays: 0,
    ssnit: '',
    paye: '',
    hasBenefits: 'No',
    benefits: [
      { type: '', amount: '' }
    ],
   includeTermination: true,
    noticePeriod: 30,
    terminationReasonRequired: 'Yes',
    terminationConditions: 'Either party may terminate this contract by providing written notice as specified in the notice period section.'
  });
  
  // Watch for changes to auto-calculate end date
  watch(() => [contract.value.startDate, contract.value.duration, contract.value.autoCalculateEndDate], 
    ([startDate, duration, autoCalculate]) => {
      if (autoCalculate && startDate && duration) {
        const start = new Date(startDate);
        start.setMonth(start.getMonth() + parseInt(duration));
        contract.value.endDate = start.toISOString().split('T')[0];
      }
    },
    { deep: true }
  );
  
  // Methods
  const addSubject = () => {
    contract.value.subjects.push('');
  };
  
  const removeSubject = (index) => {
    contract.value.subjects.splice(index, 1);
  };
  const addBenefit = () => {
  contract.value.benefits.push({
    type: '',
    amount: ''
  });
};

const removeBenefit = (index) => {
  contract.value.benefits.splice(index, 1);
};
  const resetForm = () => {
    contract.value = {
      type: '',
      duration: 0,
      probationPeriod: '3',
      startDate: '',
      endDate: '',
      language: '',
      report: '',
      autoCalculateEndDate: true,
      department: '',
      position: '',
      section: '',
      class: '',
      subjects: [''],
      salary: 0,
      paymentFrequency: 'monthly',
      leaveDays: 0,
      ssnit: '',
      paye: '',
      hasBenefits: 'No',
      benefits: [
        { type: '', amount: '' }
      ],
      includeTermination: true,
      noticePeriod: 30,
      terminationReasonRequired: 'Yes',
      terminationConditions: 'Either party may terminate this contract by providing written notice as specified in the notice period section.'
    };
  };
  
  // const saveDraft = () => {
  //    // Basic validation
  // if (!contract.value.employee || !contract.value.type || !contract.value.department) {
  //   alert('Please fill all required fields before saving draft');
  //   return;
  // }
  
  // };


// Save Contract Function
const saveContract = async () => {
  // Validate required fields
  if (!contract.value.employee) {
    alert('Please select an employee');
    return;
  }
  if (!contract.value.type) {
    alert('Please select contract type');
    return;
  }
  if (!contract.value.startDate) {
    alert('Please select start date');
    return;
  }
  // if (!contract.value.salary) {
  //   alert('Please enter salary');
  //   return;
  // }
  
  try {
    isSaving.value = true;
    
    // Prepare data (remove empty subjects)
    const payload = {
      employee: contract.value.employee,
      type: contract.value.type,
      duration: contract.value.duration,
      probationPeriod: contract.value.probationPeriod,
      startDate: contract.value.startDate,
      endDate: contract.value.endDate,
      language: contract.value.language,
      report: contract.value.report,
      department: contract.value.department,
      position: contract.value.position,
      section: contract.value.section || null,
      class: contract.value.class || null,
      subjects: contract.value.subjects.filter(s => s !== ''),
      salary: contract.value.salary,
      paymentFrequency: contract.value.paymentFrequency,
      leaveDays: contract.value.leaveDays,
      ssnit: contract.value.ssnit,
      paye: contract.value.paye,
      hasBenefits: contract.value.hasBenefits,
      benefits: contract.value.benefits,
      noticePeriod: contract.value.noticePeriod,
      terminationReasonRequired: contract.value.terminationReasonRequired,
      terminationConditions: contract.value.terminationConditions
    };
    
    // Call API
    const response = await api.post('SaveContract.php', payload);
    
    if (response.data.success) {
      alert('✅ Contract saved! Ref: ' + response.data.contract_number);
      console.log('Contract ID:', response.data.contract_id);

      resetForm();
    } else {
      alert('❌ Error: ' + response.data.error);
    }
    
  } catch (error) {
    console.error(error);
    alert('❌ Failed to save contract');
  } finally {
    isSaving.value = false;
  }
};
  

const generateContract = async () => {
  if (!contract.value.employee) {
    alert('Please select an employee');
    return;
  }
  
  if (!hasAcceptedDraft.value) {
    alert('No accepted draft found. Please save and submit a contract first.');
    return;
  }
  
  if (!generatedEmployeeCode.value) {
    alert('Employee code not generated. Please refresh and try again.');
    return;
  }
  
  if (!confirm('Generate contract for ' + selectedEmployeeDetails.value?.name + '?')) {
    return;
  }
  
  try {
    isSaving.value = true;
    
    const draftId = existingDraft.value?.id || 0;
    
    const payload = {
      applicant_id: contract.value.employee,
      draft_id: draftId,
      employee_code: generatedEmployeeCode.value,

      // ✅ Salary & benefits fields
      basic_salary: contract.value.salary || null,
      payment_frequency: contract.value.paymentFrequency || null,
      leaveDays: contract.value.leaveDays || null,
      hasBenefits: contract.value.hasBenefits || null,
      ssnit: contract.value.ssnit || null,
      benefits: contract.value.hasBenefits === 'Yes'
        ? contract.value.benefits.filter(b => b.type && b.amount)
        : []
    };
    
    const response = await api.post('FinalizeContract.php', payload);
    
    if (response.data.success) {
      alert('✅ Contract generated successfully!\nEmployee Code: ' + generatedEmployeeCode.value);
      resetForm();
      emit('submit', {
        contractId: response.data.contract_id,
        employeeCode: generatedEmployeeCode.value
      });
    } else {
      throw new Error(response.data.error || 'Failed to generate contract');
    }
    
  } catch (error) {
    console.error('Generate contract error:', error);
    alert('❌ Error: ' + error.message);
  } finally {
    isSaving.value = false;
  }
};

watch(() => contract.value.section, () => {
  contract.value.class = "";
});

// Watch for employee selection and check for accepted draft
watch(() => contract.value.employee, async (newApplicantId) => {
  // Reset when no employee selected
  if (!newApplicantId) {
    resetFormFields();
    generatedEmployeeCode.value = '';
    hasAcceptedDraft.value = false;
    existingDraft.value = null;
    return;
  }
  
  await checkAndPrefillFromDraft(newApplicantId);
});

console.log(contract.value.benefits, typeof contract.value.benefits);

const updateContract = async () => {
  try {
    isSaving.value = true;

    const payload = {
      draft_id: existingDraft.value.id,

      employee: contract.value.employee,
      type: contract.value.type,
      duration: contract.value.duration,
      probationPeriod: contract.value.probationPeriod,
      startDate: contract.value.startDate,
      endDate: contract.value.endDate,
      language: contract.value.language,
      report: contract.value.report,
      department: contract.value.department,
      position: contract.value.position,
      section: contract.value.section,
      class: contract.value.class,

      subjects: contract.value.subjects.filter(s => s),

      salary: contract.value.salary,
      paymentFrequency: contract.value.paymentFrequency,
      leaveDays: contract.value.leaveDays,
      ssnit: contract.value.ssnit,
      paye: contract.value.paye,

      hasBenefits: contract.value.hasBenefits,
      benefits: contract.value.benefits,

      noticePeriod: contract.value.noticePeriod,
      terminationReasonRequired:
        contract.value.terminationReasonRequired,

      terminationConditions:
        contract.value.terminationConditions
    };

    const response = await api.post(
      'UpdateContractDraft.php',
      payload
    );

    if (response.data.success) {
      alert('✅ Draft updated successfully');
    } else {
      alert(response.data.error);
    }

  } catch (error) {
    console.error(error);
    alert('Failed to update draft');
  } finally {
    isSaving.value = false;
  }
};

// Check for accepted draft and prefill form
const checkAndPrefillFromDraft = async (applicantId) => {
  try {
    isPrefilling.value = true;
    hasAcceptedDraft.value = false;
    
    // Call our new API
    const response = await api.post('GenerateEmployeeCode.php', {
      applicant_id: applicantId
    });
    
    if (response.data.success && response.data.draft) {
      // ✅ Draft found - prefill form
      hasAcceptedDraft.value = true;
      generatedEmployeeCode.value = response.data.employee_code;
      
      prefillFormFromDraft(response.data.draft);
      
      console.log('✅ Form pre-filled from accepted draft');
    } else {
      // No accepted draft - clear code, keep form empty
      resetFormFields();
      generatedEmployeeCode.value = '';
      hasAcceptedDraft.value = false;
      console.log('ℹ️ No accepted draft found');
    }
  } catch (error) {
    console.error('Error checking draft:', error);
    // Don't block user - just log error
  } finally {
    isPrefilling.value = false;
  }
};


const prefillFormFromDraft = (draft) => {
  existingDraft.value = draft;

  // Ensure benefits is always an array
  const prefilledBenefits = Array.isArray(draft.benefits) && draft.benefits.length > 0
    ? draft.benefits.map(b => ({
        type: String(b.type),
        amount: b.amount
      }))
    : [{ type: '', amount: '' }];

  contract.value = {
    ...contract.value,
    employee: draft.applicant_id,
    type: draft.contract_type_id || '',
    duration: draft.duration || '0',
    probationPeriod: draft.probation_period,
    startDate: draft.start_date || '',
    endDate: draft.end_date || '',
    language: draft.language || '',
    report: draft.report_to || '',
    department: draft.department_id || '',
    position: draft.position_id || '',
    section: draft.section_id || '',
    class: draft.class_id || '',
    subjects: draft.subjects?.length ? draft.subjects.map(s => String(s.id)) : [''],
    salary: draft.basic_salary || 0,
    paymentFrequency: draft.payment_frequency || 'monthly',
    leaveDays: draft.leave_days || 0,
    ssnit: draft.ssnit || 'No',
    paye: draft.paye || 'No',
    hasBenefits: draft.hasBenefits || 'No',
    benefits: prefilledBenefits,
    includeTermination: draft.termination_required === 'Yes',
    noticePeriod: draft.notice_period_days || 30,
    terminationReasonRequired: draft.termination_required || 'No',
    terminationConditions: draft.termination_condition || ''
  };
};

watch(() => contract.value.hasBenefits, (val) => {
  if (val === 'Yes' && (!Array.isArray(contract.value.benefits) || contract.value.benefits.length === 0)) {
    contract.value.benefits = [{ type: '', amount: '' }];
  }
});

// Reset form fields but keep employee selection
// const resetFormFields = () => {
//   contract.value = {
//     employee: contract.value.employee, 
//     type: '',
//     duration: 12,
//     probationPeriod: '3',
//     startDate: '',
//     endDate: '',
//     language: '',
//     autoCalculateEndDate: true,
//     department: '',
//     position: '',
//     section: '',
//     class: '',
//     subjects: [''],
//     salary: 0,
//     paymentFrequency: 'monthly',
//     leaveDays: 0,
//     ssnit: 'No',
//     benefits: '',
//     includeTermination: true,
//     noticePeriod: 30,
//     terminationReasonRequired: 'No',
//     terminationConditions: ''
//   };
  
//   // Clear draft-related state
//   generatedEmployeeCode.value = '';
//   hasAcceptedDraft.value = false;
//   existingDraft.value = null;
// };

const resetFormFields = () => {
  contract.value = {
    ...contract.value,
    type: '',
    duration: 0,
    probationPeriod: '3',
    startDate: '',
    endDate: '',
    language: '',
    autoCalculateEndDate: false,
    department: '',
    position: '',
    section: '',
    class: '',
    subjects: [''],
    salary: 0,
    paymentFrequency: 'monthly',
    leaveDays: 0,
    ssnit: 'No',
    hasBenefits: 'No',
    benefits: [{ type: '', amount: '' }],
    includeTermination: true,
    noticePeriod: 30,
    terminationReasonRequired: 'No',
    terminationConditions: ''
  };

  generatedEmployeeCode.value = '';
  hasAcceptedDraft.value = false;
  existingDraft.value = null;
};


const handleDownloadContract = async () => {
  if (!hasAcceptedDraft.value) {
    alert("Please generate a draft first before downloading!");
    return;
  }

  const employeeName = selectedEmployeeDetails.value?.name || "Employee";

  const payload = {
    contractNumber: `CON-${Date.now()}`,
    employeeName: employeeName,
    employeeCode: generatedEmployeeCode.value || "N/A",
    position: positions.value.find(p => p.id === contract.value.position)?.name || "N/A",
    department: departments.value.find(d => d.id === contract.value.department)?.name || "N/A",
    startDate: contract.value.startDate || "N/A",
    endDate: contract.value.endDate || "Indefinite",
    salary: contract.value.salary || 0,
    paymentFrequency: contract.value.paymentFrequency || "monthly",
    leaveDays: contract.value.leaveDays || 0,
    probationPeriod: contract.value.probationPeriod || 3,
    noticePeriod: contract.value.noticePeriod || 30,
    terminationConditions: contract.value.terminationConditions || "",
    benefits: contract.value.benefits?.filter(b => b.type) || []
  };

  try {
    const response = await api.post('GenerateContractPDF.php', payload, {
      responseType: 'blob'
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${employeeName.replace(/\s+/g, '_')}_Employment_Contract.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();

    alert("✅ Professional PDF downloaded successfully!");

  } catch (error) {
    console.error("PDF Download Error:", error);
    alert("Failed to download PDF. Please check server logs.");
  }
};

  onMounted(() => {
    fetchApplicants();
    fetchContractType();
    fetchDepartments();
    fetchPositions();
    fetchSections();
    fetchClasses();
    fetchSubjects();
    fetchBenefits();
  })
  </script>
  
  <style scoped>
  /* Add any custom styles here */
  </style>